export default "__VITE_ASSET__CQgZy4cP__"